import React, { useEffect, useState } from "react";
import { FaCircleExclamation } from "react-icons/fa6";
import { MdOutlineRefresh } from "react-icons/md";
import socket from "../Socket";
import { setDataSyncTime } from "../../store/slices/userSlice";
import { getDataSync } from "../../services/apiService/userApi";
import { useDispatch } from "react-redux";

const CheckDataSync = ({ children }) => {
  const [isChanged, setIsChanged] = useState(false);
  let dispatch = useDispatch();

  useEffect(() => {
    if (isChanged) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isChanged]);

  useEffect(() => {
    const handleSchedulerUpdate = async (data) => {
      if (data?.status) {
        setIsChanged(true);
        const dataSync = await getDataSync();
        let data = dataSync?.data?.[0];

        const formatDate = (inputDate) => {
          const date = new Date(inputDate);
          const pad = (n) => n.toString().padStart(2, "0");

          return (
            `${pad(date.getMonth() + 1)}/${pad(
              date.getDate()
            )}/${date.getFullYear()} ` +
            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
              date.getSeconds()
            )}`
          );
        };

        let dataSyncValue = {
          id: data.id || "",
          value: formatDate(data.date),
        };
        dispatch(setDataSyncTime(dataSyncValue))
      }
    };

    socket.on("startScheduler", handleSchedulerUpdate);
  }, []);

  let HandleChange = () => {
    window.location.reload();
  };

  return (
    <div className="relative">
      {isChanged && (
        <>
          <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm pointer-events-none select-none" />
          <div className="fixed top-0 left-0 z-50 w-full bg-[#EEF2FA] text-[#1C40CA] border-b justify-center flex h-[64px] items-center gap-2 text-sm font-medium shadow-sm px-4">
            <div className="flex flex-row">
              <FaCircleExclamation className="w-5 h-5 text-[#1C40CA]" />
              <div className="text-[16px] flex-1 ml-4">
                <span className="font-medium">
                  The system has synced your data. Please reload the page to
                  view the latest updates.
                </span>
              </div>
            </div>

            <button
              className="w-[140px] flex rounded-md justify-center items-center h-[32px] bg-[#1C40CA] text-white text-[13px]"
              onClick={HandleChange}
            >
              <MdOutlineRefresh />
              Reload Page
            </button>
          </div>
        </>
      )}

      <div className={`relative z-10 ${isChanged ? "pt-[64px]" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default CheckDataSync;
